import React, { FunctionComponent } from 'react';
import { Campaign as CampaignType } from '@shared/types/mylounge';
import { GridBlockDimensions } from './grid/constants';
import OpenCampaign from './open-campaign';

interface Props {
    campaign: CampaignType;
    dimension: GridBlockDimensions;
    campaignStyles: any;
    isPlusEnabled: boolean;
    position: string;
}

export const Campaign: FunctionComponent<Props> = ({
    campaign,
    dimension,
    campaignStyles,
    isPlusEnabled,
    position,
}) => {
    const campaignStyle = {
        left: `${campaignStyles.left}%`,
        paddingTop: `${campaignStyles.paddingTop}%`,
        width: `${campaignStyles.width}%`,
        marginTop: `${campaignStyles.marginTop}%`,
    };

    return (
        <OpenCampaign
            campaign={campaign}
            dimension={dimension}
            campaignStyles={campaignStyle}
            isPlusEnabled={isPlusEnabled}
            position={position}
        />
    );
};

export default Campaign;
